import React from 'react'
import "./Spinner.scss"

function Spinner() {
  return (
    <main className='spinit'></main>
  )
}

export default Spinner